import { render, staticRenderFns } from "./TabsToSpaces.vue?vue&type=template&id=751c607a"
import script from "./TabsToSpaces.vue?vue&type=script&lang=js"
export * from "./TabsToSpaces.vue?vue&type=script&lang=js"
import style0 from "./TabsToSpaces.vue?vue&type=style&index=0&id=751c607a&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports